import { SEO } from "@/components/SEO";
import { headTageTitle } from "@/utils/head-tag-title";
import { getConfigSSR } from "api/config";
import { useMemo } from "react";
import { useAppSelector } from "store/hooks";
import { ConfigPage, NextPageWithLayoutAndPageType } from "types/index";

const TermsAndConditionPage: NextPageWithLayoutAndPageType = (props: any) => {
  const storeConfig = useAppSelector((state) => state.config);
  const config = props.config || storeConfig;
  const siteTitleFromHeadTag = useMemo(() => headTageTitle(config), [config]);

  const siteName = siteTitleFromHeadTag
    ? siteTitleFromHeadTag
    : config.company_info?.name;
  const seoconfig = config.pages?.find(
    (page: ConfigPage) => page?.page_type === "terms_and_conditions",
  )?.config;
  const description =
    seoconfig?.description ||
    `Read the terms and conditions for using ${siteName} services. Understand our policies for ticket booking, refunds, and user conduct.`;
  const title = seoconfig?.title || "Terms and Conditions";
  const keywords = seoconfig?.keywords || [
    "terms",
    "conditions",
    "policy",
    "legal",
    siteName,
  ];

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      siteName={siteName}
    />
  );
};

TermsAndConditionPage.page_type = "terms_and_conditions";
export const getServerSideProps = getConfigSSR;

export default TermsAndConditionPage;
